<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click="closePopup">
        <div class="bg-white" @click="($event) => $event.stopPropagation()">
          <h1 class="title">{{ privatePlanPurchaseData.purchase.codigo }}</h1>
          <p style="text-align: center;">Este código pertenece a un taller privado</p>
          <h3>{{ privatePlanPurchaseData.purchase.titulo }}</h3>
          <p><b>Observaciones:</b> {{ privatePlanPurchaseData.purchase.observaciones }}<br><b>Plazas:</b> {{ privatePlanPurchaseData.purchase.plazas }}<br><b>Fecha:</b> {{ formatFecha(privatePlanPurchaseData.purchase.fecha) }} a las {{ formatHora(privatePlanPurchaseData.purchase.fecha) }}</p>
          <p class="user-info-block" style="margin-top: 30px;">Usuario responsable del grupo:</p>
          <div class="user-info">
            <img :src="privatePlanPurchaseData.user.foto" alt="Imagen del usuario" class="circular-image" />
            <div class="user-text">
              <h2 style="margin-bottom: 0px; margin-top: 0px;">{{ privatePlanPurchaseData.user.nombre }}</h2>
              <label>{{ privatePlanPurchaseData.user.email }}</label>
            </div>
          </div>

          <button v-if="privatePlanPurchaseData.purchase.estado == 'Pendiente'" @click="redeemPrivatePlan" class="main_button-green" :class="redeemButtonClass" style="margin-top: 30px;">Canjear</button>
          <p v-else-if="privatePlanPurchaseData.purchase.estado == 'Canjeado'" style="margin-top: 30px; text-align: center;">Este taller ya ha sido canjeado</p>
          <p v-else style="margin-top: 30px; text-align: center;">Este taller ha caducado</p>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineEmits, defineProps } from 'vue';
  import { format, parse } from 'date-fns';
  import { es } from 'date-fns/locale';
  import { useLoadingStore } from "@/stores/loadingStore";
  import { refreshToken } from "@/services/authService";
  import { useRouter } from 'vue-router';

  const props = defineProps({
    privatePlanPurchaseData: Object,
  });
  
  const loadingStore = useLoadingStore();
  const emit = defineEmits(['errorRedeeming', 'successRedeeming']);
  const router = useRouter();

  const visible = ref(false);

  watch(() => props.privatePlanPurchaseData, (newVal) => {
    visible.value = !!newVal;
  });
  
  const closePopup = () => {
    visible.value = false;
    history.back();
  };

  const formatFecha = (fecha) => {
    const fechaAux = parse(fecha, "yyyy-MM-dd HH:mm:ss", new Date());
    return format(fechaAux, "dd MMM yyyy", { locale: es });
  };

  const formatHora = (fecha) => {
    const fechaAux = parse(fecha, "yyyy-MM-dd HH:mm:ss", new Date());
    return format(fechaAux, "HH:mm", { locale: es });
  };

const redeemPrivatePlan = async () => {
  loadingStore.setLoading(true);
  try {
    let response = await fetchRedeemPrivatePlan(props.privatePlanPurchaseData.purchase.codigo);

    if (response.status === 401) {
      const refreshed = await refreshToken();
      if (refreshed) {
        response = await fetchRedeemPrivatePlan(props.privatePlanPurchaseData.purchase.codigo);
      } else {
        loadingStore.setLoading(false);
        localStorage.removeItem('user_id');
        localStorage.removeItem('token');
        router.push('/');
        return;
      }
    }

    if (!response.ok) {
      emit('errorRedeeming', "Se ha producido un error canjeando el taller privado.");
    }

    const data = await response.json();

    if (data.errors) {
      loadingStore.setLoading(false);
      emit('errorRedeeming', data.message);
    } else {
      loadingStore.setLoading(false);
      emit('successRedeeming');
    }
  } catch (exception) {
    loadingStore.setLoading(false);
    emit('errorRedeeming', exception.message);
  } finally {
    visible.value = false;
    history.back();
  }
};

async function fetchRedeemPrivatePlan(codigo) {
  return await fetch(process.env.VUE_APP_API_URL+"api/dashboard/redeems/redeem_private_plan", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vdas": process.env.VUE_APP_API_VDAS,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "purchase_code": codigo
      }),
    });
}

  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10;
  }
  
  .bg-white {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 80%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
  }
  
  .circular-image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 20px;
  }

  .user-info-block {
    border-top: 1px solid var(--very-clear-gray);
    margin-top: 0px;
    padding-top: 15px;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .user-text {
    display: flex;
    flex-direction: column;
  }

  .user-text h2 {
    width: 100%;
  }
  
  .products {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    border-top: 1px solid var(--very-clear-gray);
    padding-top: 15px;
  }

  .products h3 {
    font-weight: normal;
  }

  .button-disabled {
    opacity: 0.5;
  }

  .button-enabled {
    opacity: 1;
  }

  .title {
    border-bottom: 1px solid var(--very-clear-gray);
    text-align: center;
    margin-top: 0px;
  }

  </style>
  